import { useTranslation } from 'react-i18next';

interface SubscribeButtonProps {
  buttonColor: string;
  buttonTextColor: string;
  submitForm: () => void;
}

export const SubscribeButton = ({ buttonColor, buttonTextColor, submitForm }: SubscribeButtonProps) => {
  const { t } = useTranslation();
  return (
    <button
      type='button'
      onClick={submitForm}
      className='font-semibold min-[350px]:w-[124px] lg:w-full h-[44px] font-body py-1 px-3 mt-2 text-center flex justify-center items-center rounded outline-none focus:border-none focus:outline-none'
      style={{ color: buttonTextColor, backgroundColor: buttonColor }}
    >
      {t('subscribeWidget.subscribe')}
    </button>
  );
};
